<template>

  <div class="category-link">
    <div class="label" v-if="category !== undefined">{{ category.name }}</div>
  </div>

</template>

<script>

export default {
  name: 'CategoryLink',
  props: ['id'],
  computed: {
    category () {
      return this.$store.state.categories[this.id]
    }
  }
}

</script>

<style lang="scss" scoped>

.label {
  display: inline;
}

.id {
  display: inline;
  color: gray;
  margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/links/Category.vue